import { WindowsContainer } from '../../containers/advancedFilters/WindowsContainer';
import { IFilter } from '../../types/filters';

export const windows: IFilter = {
  component: WindowsContainer,
};
